var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentStatsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_1609_42982)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 46.5,
    height: 46.5,
    rx: 11.25,
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.503 21.6a6.6 6.6 0 100-13.2 6.6 6.6 0 000 13.2zM21.5 38.102c2.985 0 5.716-.69 7.722-1.837 1.99-1.137 3.378-2.798 3.378-4.764 0-1.965-1.388-3.626-3.378-4.763-2.006-1.146-4.737-1.837-7.722-1.837-2.985 0-5.716.69-7.722 1.837-1.99 1.137-3.378 2.798-3.378 4.764 0 1.965 1.388 3.626 3.378 4.763 2.006 1.146 4.737 1.837 7.722 1.837z",
    stroke: "#04756F",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.503 15a6 6 0 11-12 0 6 6 0 0112 0z",
    fill: "url(#paint1_linear_1609_42982)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31.502c0 3.313-4.701 6-10.5 6s-10.5-2.687-10.5-6c0-3.314 4.701-6 10.5-6s10.5 2.686 10.5 6z",
    fill: "url(#paint2_linear_1609_42982)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.128 15a5.625 5.625 0 11-11.25 0 5.625 5.625 0 0111.25 0zm4.497 16.502c0 1.464-1.042 2.863-2.886 3.917-1.834 1.047-4.393 1.708-7.239 1.708s-5.405-.66-7.239-1.709c-1.844-1.053-2.886-2.452-2.886-3.916 0-1.465 1.042-2.864 2.886-3.918 1.834-1.047 4.393-1.707 7.239-1.707s5.405.66 7.239 1.707c1.844 1.054 2.886 2.453 2.886 3.918z",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.604 15a5.094 5.094 0 00-2.175-4.179l-.331.474.331-.474a5.1 5.1 0 00-4.672-.613l-.666.243.35.617A7.943 7.943 0 0129.475 15v.001a7.93 7.93 0 01-1.036 3.933l-.35.616.666.244A5.1 5.1 0 0035.605 15zm0 0s0 0 0 0h-.6.6s0 0 0 0zM32.28 35.595l-.92 1.005h1.363c1.965 0 3.78-.53 5.12-1.418 1.335-.884 2.261-2.173 2.261-3.682 0-1.508-.927-2.797-2.263-3.681-1.341-.888-3.156-1.418-5.123-1.417h-1.363l.921 1.005c1.024 1.117 1.7 2.486 1.7 4.096 0 1.608-.675 2.977-1.696 4.092z",
    stroke: "#04756F",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.504 31.5c0 2.486-3.054 4.5-6.781 4.5 1.098-1.2 1.854-2.707 1.854-4.497 0-1.792-.758-3.3-1.859-4.501 3.73-.002 6.786 2.014 6.786 4.498zm-4.5-16.5a4.5 4.5 0 01-6.043 4.23A8.532 8.532 0 0030.075 15c0-1.537-.405-2.98-1.113-4.228A4.501 4.501 0 0135.004 15z",
    fill: "url(#paint3_linear_1609_42982)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.45 15c0-1.438-.34-2.799-.943-4.003A4.123 4.123 0 0134.63 15v0a4.124 4.124 0 01-5.123 4.006A8.905 8.905 0 0030.45 15zm0 0s0 0 0 0h-.375.375s0 0 0 0zm8.68 16.5c0 1.077-.662 2.1-1.826 2.87-.98.649-2.288 1.097-3.756 1.22.847-1.136 1.404-2.504 1.404-4.087 0-1.585-.559-2.954-1.408-4.092 1.469.123 2.778.572 3.759 1.22 1.164.771 1.826 1.793 1.826 2.87z",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1609_42982",
    x1: 24.5,
    y1: 0,
    x2: 24.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1609_42982",
    x1: 21.5,
    y1: 25.502,
    x2: 21.5,
    y2: 37.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1609_42982",
    x1: 21.5,
    y1: 25.502,
    x2: 21.5,
    y2: 37.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1609_42982",
    x1: 34.233,
    y1: 10.499,
    x2: 34.233,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentStatsImg);
export default __webpack_public_path__ + "static/media/agent-stats-img.4bd6f76a4d3d956112650c0b0cd621ce.svg";
export { ForwardRef as ReactComponent };